



import { Component, Provide, Vue } from "vue-property-decorator";

@Component({
  name: "WikiMap",
  components: {},
})
class WikiMapPage extends Vue {
  @Provide() iconFolder = "WikiMap/labels";
  @Provide() bgFolder = "WikiMap/background";
  @Provide() posterFolder = "WikiMap/poster";
  @Provide() galleryFolder = "WikiMap/gallery";
  @Provide() categoryFolder = "WikiMap/category";
}
export default WikiMapPage;
